export const withoutMemberId = (draft: ReadonlySet<string>, membershipId: string): Set<string> => {
  const next = new Set(draft);
  next.delete(membershipId);

  return next;
};
